import React, { useState, useEffect } from "react";
import toast from 'react-hot-toast';

import { createDomain, getDomains, deleteDomain } from "Shared/utils/APIUtils";
import useCreateForm from "Shared/utils/customHooks";

function AdminDomains() {
  const [domains, setDomains] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deletedDomainID, setDeletedDomainID] = useState(null);

  useEffect(() => {
    getDomains().then(response => {
      setDomains(response);
    }).catch(error => {
      toast.error('Failed to load domains');
      console.log(error);
    });
  }, []);

  const CreateNewDomain = () => {
    setIsLoading(true);

    createDomain({ name: inputs.name, domain: inputs.domain }).then(response => {
      toast.success('Added domain');
      setIsLoading(false);
      setDomains(prev => [...prev, response]);
    }).catch(error => {
      setIsLoading(false);
      toast.error('Failed to create domain');
      console.log(error);
    });
  }

  const deleteSelectedDomain = (id, index) => {
    deleteDomain(id).then(() => {
      setDeletedDomainID(index);
      toast.success('Domain deleted');
    }).catch(error => {
      toast.error('Failed to delete domain');
      console.log(error);
    });
  }

  const {
    inputs,
    handleInputChange,
    handleSubmit
  } = useCreateForm({ name: '', domain: '' }, CreateNewDomain);

  return (
    <div>
      <form className="card bg-gray" onSubmit={handleSubmit}>
        <div className="card-header">
          <div className="card-subtitle">Add allowed domain</div>
        </div>
        <div className="card-body form-horizontal">
          <div className="form-group">
            <div className="col-4 col-sm-12">
              <label className="form-label">Name</label>
            </div>
            <div className="col-8 col-sm-12">
              <input
                id="name"
                name="name"
                onChange={handleInputChange}
                value={inputs.name}
                type="text"
                className="form-input input-sm mb-2"
                placeholder="Organisation name"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="col-4 col-sm-12">
              <label className="form-label">Domain</label>
            </div>
            <div className="col-8 col-sm-12">
              <input
                id="domain"
                name="domain"
                onChange={handleInputChange}
                value={inputs.domain}
                type="text"
                className="form-input input-sm"
                placeholder="example.com"
              />
            </div>
          </div>

          <button className={`btn btn-block btn-sm mt-1 ${isLoading ? 'loading' : ''}`} type="submit">Add</button>
        </div>
      </form>
      <div className="styled-list card">
        <div className="card-body">
          {!domains.length > 0 &&
            <div className="loading loading-lg"></div>
          }
          {domains.map((domain, index) => (
            <div className={`styled-list-item ${deletedDomainID === index ? 'is-hidden' : ''}`} key={domain.id}>
              <div className="styled-list-content">
                {domain.name} ({domain.domain})
                <div className="btn-group btn-group-block">
                  <div className="popover popover-left">
                    <span className="btn btn-sm btn-error">
                      <i className="icon icon-delete"></i>
                    </span>
                    <div className="popover-container popup-box">
                      <h5 className="popup-box-title">Are you sure?</h5>
                      <button className="btn btn-sm btn-error ml-1" onClick={() => deleteSelectedDomain(domain.id, index)}>
                        Delete Domain
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminDomains;
